/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SuprSendJwtTokenRequest
 */
export interface SuprSendJwtTokenRequest {
    /**
     * User ID for the JWT token
     */
    user_id: string;
    /**
     * Tenant ID for the JWT token scope
     */
    tenant_id?: string;
    /**
     * Token expiration time in seconds
     */
    expires_in?: number;
}

/**
 * Check if a given object implements the SuprSendJwtTokenRequest interface.
 */
export function instanceOfSuprSendJwtTokenRequest(value: object): value is SuprSendJwtTokenRequest {
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    return true;
}

export function SuprSendJwtTokenRequestFromJSON(json: any): SuprSendJwtTokenRequest {
    return SuprSendJwtTokenRequestFromJSONTyped(json, false);
}

export function SuprSendJwtTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuprSendJwtTokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'tenant_id': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'expires_in': json['expires_in'] == null ? undefined : json['expires_in'],
    };
}

export function SuprSendJwtTokenRequestToJSON(json: any): SuprSendJwtTokenRequest {
    return SuprSendJwtTokenRequestToJSONTyped(json, false);
}

export function SuprSendJwtTokenRequestToJSONTyped(value?: SuprSendJwtTokenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['user_id'],
        'tenant_id': value['tenant_id'],
        'expires_in': value['expires_in'],
    };
}

